import React, { FC, memo } from 'react';
import cls from './Table.module.css';
import classNames from 'classnames';
import { TableHeader } from './TableHeader/TableHeader';
import { StageItem } from './StageItem/StageItem';

export const Table = memo(({ stages }) => {
    return (
        <div className={classNames(cls.Table)}>
            <TableHeader />
            {stages.map((stage, index) => (
                <StageItem key={stage.id} stage={stage} hintTarget={index === 0 ? 'schedule-first-stage' : undefined} />
            ))}
        </div>
    );
});
